import { getDeviceInfo } from "../Upshow";

const defaultModelConfig = {
    activationScreen: {
        isMultiStep: false,
        salesCTAText: "",
        salesPhone: "",
        onlyAvailableHelper: "",
        coBrandedLogo: "",
        promoCode: false,
        headerTitle: "Live Sports Streaming for Your Business",
        headerSubtitle: "NFL Sunday Ticket, Peacock Sports Pass and more – built for commercial businesses and venues.",
        landingTitle: "Have an Active EverPass Subscription?",
        landingSubtitle: "Sign in with your EverPass credentials to stream your purchased packages.",
        activateButtonText: "Activate Now",
        instructionTitle: "Activate Your Subscription",
        qrPairingTitle: "Pair Device Using a Phone or Tablet",
        qrPairingSubtitle: "Scan this QR code from your phone or tablet and sign in to start streaming content.",
        computerPairingTitle: "Pair Device Using a Computer",
        computerPairingSubtitlePrefix: "Go to ",
        computerPairingSubtitleSuffix: " on your computer to link this device and start streaming.",
        activationCodeLabel: "Activation Code",
    },
    epg: { scrollBehavior: "smooth" },
    inactiveState: {
        contact: "Please contact EverPass Support",
        phone: `Phone 855-787-7469`,
        email: `Email support@everpass.com`,
    },
};

const x1ModelConfig = {
    activationScreen: {
        ...defaultModelConfig.activationScreen,
        isMultiStep: true,
        salesCTAText: "Call EverPass now at",
        salesPhone: `${process.env.REACT_APP_COMCAST_SALES_NUMBER}`,
        onlyAvailableHelper: "EverPass is only available for streaming on X1 devices.",
        coBrandedLogo: "https://cdn.upshow.tv/ui-assets/comcastbusiness-logo.png",
        promoCode: true,
    },
    epg: { scrollBehavior: "auto" },
    inactiveState: {
        contact: "Please contact Charter Support",
        phone: `Phone ${process.env.REACT_APP_COMCAST_HELP_DESK_NUMBER}`,
        email: "",
    },
};

const byodModelConfig = {
    ...defaultModelConfig,
    activationScreen: {
        ...defaultModelConfig.activationScreen,
        isMultiStep: true,
    },
};

const nonPromoModelConfig = {
    ...byodModelConfig,
    activationScreen: {
        ...byodModelConfig.activationScreen,
        hidePromo: true,
        headerTitle: "Access Your EverPass Subscription",
        headerSubtitle: "EverPass delivers live sports packages to commercial businesses and venues. Sign in with your existing account to stream NFL Sunday Ticket, Peacock Sports Pass and more.",
        landingTitle: "",
        landingSubtitle: "Commercial access only.",
    },
};

const MODEL_CONFIG = {
    xumo: {
        activationScreen: {
            ...defaultModelConfig.activationScreen,
            isMultiStep: true,
            salesCTAText: "Call Spectrum Business now at",
            salesPhone: `${process.env.REACT_APP_SPECTRUM_SALES_NUMBER}`,
            onlyAvailableHelper: "",
            coBrandedLogo: "https://cdn.upshow.tv/ui-assets/Spectrum_Logo.svg",
            promoCode: false,
        },
        epg: { scrollBehavior: "auto" },
        inactiveState: {
            contact: "Please contact Charter Support",
            phone: `Phone ${process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}`,
            email: "",
        },
    },
    xi6: x1ModelConfig,
    xg2v2: { ...x1ModelConfig, epg: { customScrollBehavior: true } },
    xid: { ...x1ModelConfig, epg: { customScrollBehavior: true } },
    lgwebos: nonPromoModelConfig,
    samsungtizen: byodModelConfig,
    androidtv: nonPromoModelConfig,
    firetv: nonPromoModelConfig,
    default: defaultModelConfig,
};

const imagePlaceholderMakeConfig = {
    emptyState: { imageFallback: true },
    liveContentState: { videoPlaceholder: false },
    loadingState: { image: true },
};

const MAKE_CONFIG = {
    comcast: imagePlaceholderMakeConfig,
    amazon: imagePlaceholderMakeConfig,
    google: imagePlaceholderMakeConfig,
    default: {
        emptyState: { imageFallback: false },
        liveContentState: { videoPlaceholder: true },
        loadingState: { image: false },
    },
};

export const getModelConfig = () => {
    const model = getDeviceInfo().model.toLowerCase();
    return MODEL_CONFIG[model] || MODEL_CONFIG.default;
};

export const getMakeConfig = () => {
    const make = getDeviceInfo().make.toLowerCase();
    return MAKE_CONFIG[make] || MAKE_CONFIG.default;
};

export const getModel = () => {
    return getDeviceInfo().model.toLowerCase();
}

export const getMake = () => {
    return getDeviceInfo().make.toLowerCase();
}

export const isLowEndDevice = () => {
    return getMake() === 'comcast';
}